import Vue from 'vue'
import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import HomeHeader from '../../components/homeHeader/index.vue'
import OtpInput from '@bachdgvn/vue-otp-input'
import { showSuccessToast, showErrorToast } from '../../services/UI'
import UserService from '../../services/UserService'

Vue.component('v-otp-input', OtpInput)
export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  name: 'ActionsTab',
  data () {
    return {
      otp: '',
      timer: 0,
      pid: 0
    }
  },
  components: {
    HomeHeader
  },
  mounted () {
    window.analytics.identify('Enter OTP', {
      path: '/enter_otp'
    })
    // window.analytics.page('Enter OTP')
    console.log(this.$router.history.current.params)
    const pid = setInterval(() => {
      this.timer++
      if (this.timer >= 90) {
        this.timer = 90 // hold at 90
      }
    }, 1000)
    this.pid = pid
  },
  computed: {},
  methods: {
    handleOnComplete (value) {
      // console.log('OTP completed: ', value)
      this.otp = value
    },
    handleOnChange (value) {
      // console.log('OTP changed: ', value)
    },
    handleClearInput () {
      this.$refs.otpInput.clearInput()
    },
    handleBackEvent () {
      this.$router.go(-1)
    },
    async verifyOtp () {
      this.loading = true
      this.error = ' '
      if (!this.otp || this.otp.length !== 4) {
        this.error = 'invalid OTP.'
        showErrorToast(this, this.error)
        this.loading = false
        return
      }
      const updateToken = await UserService.verify(
        localStorage.getItem('password-token'),
        this.otp
      )
      this.loading = false
      if (updateToken) {
        this.$router.push('/create_new_password')
      } else {
        this.error = 'Invalid OTP.'
        showErrorToast(this, this.error)
      }
    },
    async resendOtp () {
      if (this.timer < 90) {
        return showErrorToast(this, `Please wait ${90 - this.timer} seconds`)
      }
      // console.log('sending')
      const email = this.$router.history.current.params.email
      const verifyToken = await UserService.requestVerify(email)
      // console.log(verifyToken)
      if (verifyToken) {
        showSuccessToast(this, 'Otp sent to your email')
        this.timer = 0
      } else {
        this.error = 'Unable to send OTP email.'
        showErrorToast(this, this.error)
      }
    }
  }
}
